export default __webpack_public_path__ + "static/fall2 (3)-f0dab5b033ce9655b6da99b4cfb05014.jpg";